import { Tab } from "bootstrap";
import {Helpers} from "./helpers";

export class TabHelper
{
	constructor() {
		if (!Helpers.elementExists(".nav-tabs")) return;
		new Tab('.nav-tabs');
		this.initSelectTabs();
	}


	initSelectTabs(): void {
		let selectTabs = document.querySelectorAll('.select-tabs') as NodeListOf<HTMLSelectElement>;
		selectTabs.forEach(selectTab => {
			let tabButtons = selectTab.parentElement.querySelectorAll('.nav-tabs button') as NodeListOf<HTMLElement>;
			let tabContent = selectTab.parentElement.querySelectorAll('.tab-pane') as NodeListOf<HTMLElement>;
			selectTab.addEventListener('change', () => {
				let currentValue = selectTab.value;
				tabButtons.forEach(button => {
					if (button.id === currentValue + "-tab") {
						button.classList.add('active');
					} else {
						button.classList.remove('active');
					};
				});
				tabContent.forEach(content => {
					if (content.id === currentValue) {
						content.classList.add('show', 'active');
					} else {
						content.classList.remove('show', 'active');
					}
				});
			});
		});
	}
}